import type { ReactNode, CSSProperties } from 'react';
import { hasRole, type Role } from '@death-star/shared';
import { useRole } from '../use-role.js';

interface Props {
  min: Role;
  children: ReactNode;
}

const spinnerWrap: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 'var(--loop-space-400)',
  color: 'var(--loop-neutral-700)',
};

const deniedWrap: CSSProperties = {
  margin: 'var(--loop-space-400) auto',
  maxWidth: '480px',
  padding: 'var(--loop-space-300)',
  background: 'var(--loop-neutral-0)',
  border: '1px solid var(--loop-neutral-300)',
  borderRadius: 'var(--loop-radius-md)',
  color: 'var(--loop-neutral-1100)',
  textAlign: 'center',
};

export function RequireRole({ min, children }: Props) {
  const { role, loading } = useRole();
  if (loading) {
    return <div style={spinnerWrap}>Loading…</div>;
  }
  if (!hasRole(role, min)) {
    return (
      <div style={deniedWrap}>
        <h3 style={{ margin: '0 0 var(--loop-space-100)' }}>Access denied</h3>
        <p style={{ margin: 0, color: 'var(--loop-neutral-900)' }}>
          You do not have access to this page. Ask a superAdmin if you need it.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
